const ContractSignType = {
  ZC: [1, 'Zingchart'],
  REVENUE: [2, 'Revenue'],
  MG: [3, 'MG'],
};

export default ContractSignType;
